import { render, staticRenderFns } from "./Spiders.vue?vue&type=template&id=2edb3ff3"
import script from "./Spiders.vue?vue&type=script&lang=js"
export * from "./Spiders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports